// Angular
import { Routes } from "@angular/router";

// Afidium
import { SearchComponent } from './containers/search/search.component';
import { ConfigSharedHotelResolver } from 'libraries/hotel/resolvers/config-shared-hotel.resolver';

// Routes
export const ROUTES: Routes = [
    {
        path: '',
        component: SearchComponent,
        resolve: {
            configSharedHotel: ConfigSharedHotelResolver
        }
    },
    {
        path: ':trips',
        component: SearchComponent,
        resolve: {
            configSharedHotel: ConfigSharedHotelResolver
        }
    }
];
